const styles = require('../Wizard.less') as any;

const promptSpacing = {
	marginTop: '12px',
	marginBottom: '-5px',
}

export { styles, promptSpacing };



// WEBPACK FOOTER //
// ./src/app/containers/Wizard/Pages/Styles.ts